const Years= [
    {
        id: '2020',
        name: '2020'
    },
    {
        id: '2021',
        name: '2021'
    },
    {
        id: '2022',
        name: '2022'
    },
    {
        id: '2023',
        name: '2023'
    },
    {
        id: '2024',
        name: '2024'
    },
    {
        id: '2025',
        name: '2025'
    },
    {
        id: '2026',
        name: '2026'
    },
    {
        id: '2027',
        name: '2027'
    },
    {
        id: '2028',
        name: '2028'
    },
    {
        id: '2029',
        name: '2029'
    },
    {
        id: '2030',
        name: '2030'
    },
    {
        id: '2031',
        name: '2031'
    },
    {
        id: '2032',
        name: '2032'
    },
    {
        id: '2033',
        name: '2033'
    },
    {
        id: '2034',
        name: '2034'
    },
    {
        id: '2035',
        name: '2035'
    },
    {
        id: '2036',
        name: '2036'
    },
    {
        id: '2038',
        name: '2038'
    },
    {
        id: '2039',
        name: '2039'
    },
    {
        id: '2040',
        name: '2040'
    }
]

export default Years;